export default {"src":"/_next/static/media/friend3.c6c89afc.svg","height":15,"width":16,"blurWidth":0,"blurHeight":0};